module.exports = __webpack_public_path__ + "img/mtn.c1afefa2.svg";